// BASIC:
import React from "react"
import "./style.sass"

// UTILITIES:
import { Link, graphql } from "gatsby"
import SEO from "../components/seo"
import { Container, Col, Row } from "react-bootstrap"
import { FiFacebook, FiTwitter, FiLinkedin } from "react-icons/fi"
import { FaWhatsapp, FaTelegramPlane } from "react-icons/fa"
import { LinkedinShareButton, TwitterShareButton, WhatsappShareButton, TelegramShareButton, FacebookShareButton } from "react-share"

// COMPONENTS:
import Bio from "../components/author-bio/bio.comp"
import Layout from "../components/layout"

// COMPONENT=>
const BlogPostTemplate = ({ data, location }) => {
  const post = data.markdownRemark
  const siteTitle = data.site.siteMetadata?.title || `Title`
  const { previous, next } = data

  const author = `salihcodev`

  let shareIt
  if (typeof window !== "undefined") shareIt = window.location.href

  return (
    <Layout location={location} title={siteTitle}>
      <SEO title={post.frontmatter.title} description={post.frontmatter.description || post.excerpt} />
      <Container fluid>
        <div className="post-wrapper">
          <Row>
            <Col lg={3}>
              <section className="social-share side-social-share">
                <div className="wrapper">
                  <h6>Share this article with your community</h6>
                  <ul>
                    <li>
                      <TwitterShareButton url={shareIt} via={author} title={post.frontmatter.title}>
                        <span className="share-it-btn" title="twitter">
                          <FiTwitter />
                        </span>
                      </TwitterShareButton>
                    </li>
                    <li>
                      <LinkedinShareButton url={shareIt} title={post.frontmatter.title} summary={post.frontmatter.description} source="https://salih.netlify.com/me">
                        <span className="share-it-btn" title="linkedin">
                          <FiLinkedin />
                        </span>
                      </LinkedinShareButton>
                    </li>
                    <li>
                      <WhatsappShareButton url={shareIt} title={post.frontmatter.title}>
                        <span className="share-it-btn" title="what's up">
                          <FaWhatsapp />
                        </span>
                      </WhatsappShareButton>
                    </li>
                    <li>
                      <TelegramShareButton url={shareIt} title={post.frontmatter.title}>
                        <span className="share-it-btn" title="telegram">
                          <FaTelegramPlane />
                        </span>
                      </TelegramShareButton>
                    </li>
                    <li>
                      <FacebookShareButton url={shareIt} quote={post.frontmatter.title}>
                        <span className="share-it-btn" title="facebook">
                          <FiFacebook />
                        </span>
                      </FacebookShareButton>
                    </li>
                  </ul>
                </div>
              </section>
            </Col>
            <Col lg={9} md={12}>
              <article className="blog-post" itemScope itemType="http://schema.org/Article">
                <header>
                  <h1 itemProp="headline">{post.frontmatter.title}</h1>
                  <code>{post.frontmatter.date}</code>
                  <code>
                    <small className="highlight purple-highlight">{post.frontmatter.timeToRead} Reading.</small>
                  </code>
                  <section className="social-share embedded-social-share">
                    <h6>Share this article with your community</h6>
                    <ul>
                      <li>
                        <TwitterShareButton url={shareIt} via={author} title={post.frontmatter.title}>
                          <span className="share-it-btn" title="twitter">
                            <FiTwitter />
                          </span>
                        </TwitterShareButton>
                      </li>
                      <li>
                        <LinkedinShareButton url={shareIt} title={post.frontmatter.title} summary={post.frontmatter.description} source="https://salih.netlify.com/me">
                          <span className="share-it-btn" title="linkedin">
                            <FiLinkedin />
                          </span>
                        </LinkedinShareButton>
                      </li>
                      <li>
                        <WhatsappShareButton url={shareIt} title={post.frontmatter.title}>
                          <span className="share-it-btn" title="what's up">
                            <FaWhatsapp />
                          </span>
                        </WhatsappShareButton>
                      </li>
                      <li>
                        <TelegramShareButton url={shareIt} title={post.frontmatter.title}>
                          <span className="share-it-btn" title="telegram">
                            <FaTelegramPlane />
                          </span>
                        </TelegramShareButton>
                      </li>
                      <li>
                        <FacebookShareButton url={shareIt} quote={post.frontmatter.title}>
                          <span className="share-it-btn" title="facebook">
                            <FiFacebook />
                          </span>
                        </FacebookShareButton>
                      </li>
                    </ul>
                  </section>
                </header>
                <section className="post-body" dangerouslySetInnerHTML={{ __html: post.html }} itemProp="articleBody" />

                <footer className="article-footer">
                  <nav className="blog-post-nav">
                    <ul className="navigators">
                      <li>
                        {previous && (
                          <Link to={previous.fields.slug} rel="prev">
                            ← {previous.frontmatter.title}
                          </Link>
                        )}
                      </li>
                      <li>
                        {next && (
                          <Link to={next.fields.slug} rel="next">
                            {next.frontmatter.title} →
                          </Link>
                        )}
                      </li>
                    </ul>
                  </nav>
                </footer>
              </article>
            </Col>
          </Row>

          {/* footer */}
          <footer className="page-footer container">
            {/* next and previous post */}
              <Bio />
            {/* author bio */}
          </footer>
        </div>
      </Container>
    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($id: String!, $previousPostId: String, $nextPostId: String) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(id: { eq: $id }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
        timeToRead
      }
    }
    previous: markdownRemark(id: { eq: $previousPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
    next: markdownRemark(id: { eq: $nextPostId }) {
      fields {
        slug
      }
      frontmatter {
        title
      }
    }
  }
`
